// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-container-yBs7x {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  overflow: hidden;
  background-color: var(--color-white);
  background-image:
    radial-gradient(ellipse at 5% 10%, color-mix(in oklch, var(--color-red-50) 65%, var(--color-red-100)), transparent 40%),
    radial-gradient(ellipse at 95% 20%, color-mix(in oklch, var(--color-orange-50) 65%, var(--color-orange-100)), transparent 40%),
    radial-gradient(ellipse at 65% 100%, color-mix(in oklch, var(--color-rose-50) 65%, var(--color-rose-100)), transparent 50%);
  padding: 32px 24px 24px;
}

.onboarding-content-Km8Xx {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0px;
  width: 560px;
  max-width: 100%;
}

.onboarding-header-YPXb7 {
  flex-shrink: 0;
  margin-bottom: 24px;
}

.onboarding-brand_container-X2Vtz {
  justify-content: center;
}

.onboarding-viewport-A07WS {
  flex: 1;
  min-height: 0px;
  overflow: hidden;
}

.onboarding-slides-GuqAp {
  display: flex;
  align-items: center;
  height: 100%;
  touch-action: pan-y pinch-zoom;
}

.onboarding-welcomeSlide_slide-YDPsD,
.onboarding-productSlide_slide-RzDNP,
.onboarding-commissionsSlide_slide-o_100,
.onboarding-activateSlide_slide-wCdp4 {
  max-height: 640px;
  overflow: hidden;
  padding: 0px 8px;
}

.onboarding-welcomeSlide_content-CKxDn,
.onboarding-productSlide_content-p3p2p,
.onboarding-commissionsSlide_content-xPSBm,
.onboarding-activateSlide_content-xa32V {
  justify-content: safe center;
  width: auto;
  min-height: 0px;
  height: 100%;
  overflow-y: auto;
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-3xl);
  padding: 32px;
}

.onboarding-welcomeSlide_title-PD4YG,
.onboarding-productSlide_title-pzhZf,
.onboarding-commissionsSlide_title-JO0Ve,
.onboarding-activateSlide_title-_2Fnw {
  font-size: var(--text-2xl);
  margin-top: 20px;
}

.onboarding-welcomeSlide_description-HUBd4,
.onboarding-productSlide_description-XY_iy,
.onboarding-commissionsSlide_description-EaFTW,
.onboarding-activateSlide_description-CIVfo {
  font-size: var(--text-base);
}

.onboarding-welcomeSlide_slide-YDPsD {
  --onboarding-accent-color: var(--color-blue-500);
  --onboarding-accent-soft: var(--color-blue-50);
}

.onboarding-productSlide_slide-RzDNP {
  --onboarding-accent-color: var(--color-red-600);
  --onboarding-accent-soft: var(--color-red-50);
}

.onboarding-commissionsSlide_slide-o_100 {
  --onboarding-accent-color: var(--color-green-700);
  --onboarding-accent-soft: var(--color-green-50);
}

.onboarding-activateSlide_slide-wCdp4 {
  --onboarding-accent-color: var(--color-slate-800);
  --onboarding-accent-soft: var(--color-slate-100);
}

.onboarding-cards-_3zEb {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 20px;
  width: 100%;
  margin-top: 24px;
}

.onboarding-bubbles-jCqOi {
  position: relative;
  flex-shrink: 0;
  width: 320px;
  max-width: 100%;
  height: 310px;
  margin-top: 20px;
}

.onboarding-bubble-U7ajY {
  position: absolute;
  object-fit: contain;
  background-color: var(--color-gray-50);
  transform: translate(-50%, -50%);
  border-radius: 50%;
  padding: 4px;
}

.onboarding-bubble-U7ajY:nth-child(1) { width: 80px; height: 80px; left: 50%; top: 155px; }
.onboarding-bubble-U7ajY:nth-child(2) { width: 58px; height: 58px; left: 75%; top: 215px; }
.onboarding-bubble-U7ajY:nth-child(3) { width: 64px; height: 64px; left: 77%; top: 95px; }
.onboarding-bubble-U7ajY:nth-child(4) { width: 60px; height: 60px; left: 22%; top: 100px; }
.onboarding-bubble-U7ajY:nth-child(5) { width: 50px; height: 50px; left: 10%; top: 162px; }
.onboarding-bubble-U7ajY:nth-child(6) { width: 50px; height: 50px; left: 90%; top: 165px; }
.onboarding-bubble-U7ajY:nth-child(7) { width: 54px; height: 54px; left: 25%; top: 217px; }
.onboarding-bubble-U7ajY:nth-child(8) { width: 48px; height: 48px; left: 12%; top: 40px; }
.onboarding-bubble-U7ajY:nth-child(9) { width: 50px; height: 50px; left: 48%; top: 60px; }
.onboarding-bubble-U7ajY:nth-child(10) { width: 52px; height: 52px; left: 80%; top: 285px; }
.onboarding-bubble-U7ajY:nth-child(11) { width: 44px; height: 44px; left: 90%; top: 39px; }
.onboarding-bubble-U7ajY:nth-child(12) { width: 50px; height: 50px; left: 20%; top: 285px; }
.onboarding-bubble-U7ajY:nth-child(13) { width: 60px; height: 60px; left: 50%; top: 260px; }

.onboarding-previousButton-jjM2E:focus-visible,
.onboarding-nextButton-QchXl:focus-visible,
.onboarding-dot-d1vwa:focus-visible {
  outline: 2px solid var(--color-blue-600);
  outline-offset: 3px;
}

.onboarding-footer-CcII4 {
  flex-shrink: 0;
  width: 800px;
  max-width: 100%;
  padding-top: 16px;
}

.onboarding-dots-LAXTb {
  display: flex;
  justify-content: center;
}

.onboarding-dot-d1vwa {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background-color: transparent;
  border: 0px;
  border-radius: var(--radius-md);
  padding: 0px;
  cursor: pointer;
}

.onboarding-dot-d1vwa::before {
  content: '';
  width: 8px;
  height: 8px;
  background-color: var(--color-neutral-300);
  border-radius: var(--radius-xl);
}

.onboarding-selectedDot-sZmz3::before {
  background-color: var(--color-blue-600);
}

.onboarding-actions-mh0gu {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
}

.onboarding-previousButton-jjM2E,
.onboarding-nextButton-QchXl {
  min-height: 40px;
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
  border: 0px;
  border-radius: var(--radius-lg);
  padding: 8px 24px;
  cursor: pointer;
}

.onboarding-previousButton-jjM2E {
  color: var(--color-blue-600);
  background-color: transparent;
  border: 1px solid var(--color-blue-600);
}

.onboarding-previousButton-jjM2E:hover:not(:disabled) {
  background-color: var(--color-blue-50);
}

.onboarding-previousButton-jjM2E:disabled {
  color: var(--color-neutral-400);
  border-color: var(--color-neutral-300);
  cursor: default;
}

.onboarding-nextButton-QchXl {
  color: var(--color-white);
  background-color: var(--color-blue-600);
}

.onboarding-nextButton-QchXl:hover {
  background-color: var(--color-blue-700);
}

@media (max-width: 600px) {
  .onboarding-container-yBs7x {
    padding: 24px 8px;
  }

  .onboarding-welcomeSlide_content-CKxDn,
  .onboarding-productSlide_content-p3p2p,
  .onboarding-commissionsSlide_content-xPSBm,
  .onboarding-activateSlide_content-xa32V {
    padding: 24px 12px;
  }

  .onboarding-welcomeSlide_title-PD4YG,
  .onboarding-productSlide_title-pzhZf,
  .onboarding-commissionsSlide_title-JO0Ve,
  .onboarding-activateSlide_title-_2Fnw {
    font-size: var(--text-xl);
  }

  .onboarding-brand_title_container-DNYWD {
    margin-left: 12px;
  }

  .onboarding-bubble-U7ajY:nth-child(5) { left: 15%; }
  .onboarding-bubble-U7ajY:nth-child(6),
  .onboarding-bubble-U7ajY:nth-child(11) { left: 85%; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/onboarding/onboarding.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC;;;+HAG6H;EAC7H,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;;;EAIE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;EAIE,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,uCAAuC;EACvC,gCAAgC;EAChC,aAAa;AACf;;AAEA;;;;EAIE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA;EACE,iDAAiD;EACjD,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;;AAEA,wCAAuB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE;AACzE,wCAAuB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE;AACzE,wCAAuB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,SAAS,EAAE;AACxE,wCAAuB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE;AACzE,wCAAuB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE;AACzE,wCAAuB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE;AACzE,wCAAuB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE;AACzE,wCAAuB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,SAAS,EAAE;AACxE,wCAAuB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,SAAS,EAAE;AACxE,yCAAwB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE;AAC1E,yCAAwB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,SAAS,EAAE;AACzE,yCAAwB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE;AAC1E,yCAAwB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE;;AAE1E;;;EAGE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;EACtC,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;;;;IAIE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA,wCAAuB,SAAS,EAAE;EAClC;2CACwB,SAAS,EAAE;AACrC","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100vh;\n  overflow: hidden;\n  background-color: var(--color-white);\n  background-image:\n    radial-gradient(ellipse at 5% 10%, color-mix(in oklch, var(--color-red-50) 65%, var(--color-red-100)), transparent 40%),\n    radial-gradient(ellipse at 95% 20%, color-mix(in oklch, var(--color-orange-50) 65%, var(--color-orange-100)), transparent 40%),\n    radial-gradient(ellipse at 65% 100%, color-mix(in oklch, var(--color-rose-50) 65%, var(--color-rose-100)), transparent 50%);\n  padding: 32px 24px 24px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0px;\n  width: 560px;\n  max-width: 100%;\n}\n\n.header {\n  flex-shrink: 0;\n  margin-bottom: 24px;\n}\n\n.brand_container {\n  justify-content: center;\n}\n\n.viewport {\n  flex: 1;\n  min-height: 0px;\n  overflow: hidden;\n}\n\n.slides {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  touch-action: pan-y pinch-zoom;\n}\n\n.welcomeSlide_slide,\n.productSlide_slide,\n.commissionsSlide_slide,\n.activateSlide_slide {\n  max-height: 640px;\n  overflow: hidden;\n  padding: 0px 8px;\n}\n\n.welcomeSlide_content,\n.productSlide_content,\n.commissionsSlide_content,\n.activateSlide_content {\n  justify-content: safe center;\n  width: auto;\n  min-height: 0px;\n  height: 100%;\n  overflow-y: auto;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-200);\n  border-radius: var(--radius-3xl);\n  padding: 32px;\n}\n\n.welcomeSlide_title,\n.productSlide_title,\n.commissionsSlide_title,\n.activateSlide_title {\n  font-size: var(--text-2xl);\n  margin-top: 20px;\n}\n\n.welcomeSlide_description,\n.productSlide_description,\n.commissionsSlide_description,\n.activateSlide_description {\n  font-size: var(--text-base);\n}\n\n.welcomeSlide_slide {\n  --onboarding-accent-color: var(--color-blue-500);\n  --onboarding-accent-soft: var(--color-blue-50);\n}\n\n.productSlide_slide {\n  --onboarding-accent-color: var(--color-red-600);\n  --onboarding-accent-soft: var(--color-red-50);\n}\n\n.commissionsSlide_slide {\n  --onboarding-accent-color: var(--color-green-700);\n  --onboarding-accent-soft: var(--color-green-50);\n}\n\n.activateSlide_slide {\n  --onboarding-accent-color: var(--color-slate-800);\n  --onboarding-accent-soft: var(--color-slate-100);\n}\n\n.cards {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  gap: 20px;\n  width: 100%;\n  margin-top: 24px;\n}\n\n.bubbles {\n  position: relative;\n  flex-shrink: 0;\n  width: 320px;\n  max-width: 100%;\n  height: 310px;\n  margin-top: 20px;\n}\n\n.bubble {\n  position: absolute;\n  object-fit: contain;\n  background-color: var(--color-gray-50);\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  padding: 4px;\n}\n\n.bubble:nth-child(1) { width: 80px; height: 80px; left: 50%; top: 155px; }\n.bubble:nth-child(2) { width: 58px; height: 58px; left: 75%; top: 215px; }\n.bubble:nth-child(3) { width: 64px; height: 64px; left: 77%; top: 95px; }\n.bubble:nth-child(4) { width: 60px; height: 60px; left: 22%; top: 100px; }\n.bubble:nth-child(5) { width: 50px; height: 50px; left: 10%; top: 162px; }\n.bubble:nth-child(6) { width: 50px; height: 50px; left: 90%; top: 165px; }\n.bubble:nth-child(7) { width: 54px; height: 54px; left: 25%; top: 217px; }\n.bubble:nth-child(8) { width: 48px; height: 48px; left: 12%; top: 40px; }\n.bubble:nth-child(9) { width: 50px; height: 50px; left: 48%; top: 60px; }\n.bubble:nth-child(10) { width: 52px; height: 52px; left: 80%; top: 285px; }\n.bubble:nth-child(11) { width: 44px; height: 44px; left: 90%; top: 39px; }\n.bubble:nth-child(12) { width: 50px; height: 50px; left: 20%; top: 285px; }\n.bubble:nth-child(13) { width: 60px; height: 60px; left: 50%; top: 260px; }\n\n.previousButton:focus-visible,\n.nextButton:focus-visible,\n.dot:focus-visible {\n  outline: 2px solid var(--color-blue-600);\n  outline-offset: 3px;\n}\n\n.footer {\n  flex-shrink: 0;\n  width: 800px;\n  max-width: 100%;\n  padding-top: 16px;\n}\n\n.dots {\n  display: flex;\n  justify-content: center;\n}\n\n.dot {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  background-color: transparent;\n  border: 0px;\n  border-radius: var(--radius-md);\n  padding: 0px;\n  cursor: pointer;\n}\n\n.dot::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  background-color: var(--color-neutral-300);\n  border-radius: var(--radius-xl);\n}\n\n.selectedDot::before {\n  background-color: var(--color-blue-600);\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.previousButton,\n.nextButton {\n  min-height: 40px;\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n  border: 0px;\n  border-radius: var(--radius-lg);\n  padding: 8px 24px;\n  cursor: pointer;\n}\n\n.previousButton {\n  color: var(--color-blue-600);\n  background-color: transparent;\n  border: 1px solid var(--color-blue-600);\n}\n\n.previousButton:hover:not(:disabled) {\n  background-color: var(--color-blue-50);\n}\n\n.previousButton:disabled {\n  color: var(--color-neutral-400);\n  border-color: var(--color-neutral-300);\n  cursor: default;\n}\n\n.nextButton {\n  color: var(--color-white);\n  background-color: var(--color-blue-600);\n}\n\n.nextButton:hover {\n  background-color: var(--color-blue-700);\n}\n\n@media (max-width: 600px) {\n  .container {\n    padding: 24px 8px;\n  }\n\n  .welcomeSlide_content,\n  .productSlide_content,\n  .commissionsSlide_content,\n  .activateSlide_content {\n    padding: 24px 12px;\n  }\n\n  .welcomeSlide_title,\n  .productSlide_title,\n  .commissionsSlide_title,\n  .activateSlide_title {\n    font-size: var(--text-xl);\n  }\n\n  .brand_title_container {\n    margin-left: 12px;\n  }\n\n  .bubble:nth-child(5) { left: 15%; }\n  .bubble:nth-child(6),\n  .bubble:nth-child(11) { left: 85%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `onboarding-container-yBs7x`,
	"content": `onboarding-content-Km8Xx`,
	"header": `onboarding-header-YPXb7`,
	"brand_container": `onboarding-brand_container-X2Vtz`,
	"viewport": `onboarding-viewport-A07WS`,
	"slides": `onboarding-slides-GuqAp`,
	"welcomeSlide_slide": `onboarding-welcomeSlide_slide-YDPsD`,
	"productSlide_slide": `onboarding-productSlide_slide-RzDNP`,
	"commissionsSlide_slide": `onboarding-commissionsSlide_slide-o_100`,
	"activateSlide_slide": `onboarding-activateSlide_slide-wCdp4`,
	"welcomeSlide_content": `onboarding-welcomeSlide_content-CKxDn`,
	"productSlide_content": `onboarding-productSlide_content-p3p2p`,
	"commissionsSlide_content": `onboarding-commissionsSlide_content-xPSBm`,
	"activateSlide_content": `onboarding-activateSlide_content-xa32V`,
	"welcomeSlide_title": `onboarding-welcomeSlide_title-PD4YG`,
	"productSlide_title": `onboarding-productSlide_title-pzhZf`,
	"commissionsSlide_title": `onboarding-commissionsSlide_title-JO0Ve`,
	"activateSlide_title": `onboarding-activateSlide_title-_2Fnw`,
	"welcomeSlide_description": `onboarding-welcomeSlide_description-HUBd4`,
	"productSlide_description": `onboarding-productSlide_description-XY_iy`,
	"commissionsSlide_description": `onboarding-commissionsSlide_description-EaFTW`,
	"activateSlide_description": `onboarding-activateSlide_description-CIVfo`,
	"cards": `onboarding-cards-_3zEb`,
	"bubbles": `onboarding-bubbles-jCqOi`,
	"bubble": `onboarding-bubble-U7ajY`,
	"previousButton": `onboarding-previousButton-jjM2E`,
	"nextButton": `onboarding-nextButton-QchXl`,
	"dot": `onboarding-dot-d1vwa`,
	"footer": `onboarding-footer-CcII4`,
	"dots": `onboarding-dots-LAXTb`,
	"selectedDot": `onboarding-selectedDot-sZmz3`,
	"actions": `onboarding-actions-mh0gu`,
	"brand_title_container": `onboarding-brand_title_container-DNYWD`
};
export default ___CSS_LOADER_EXPORT___;
